import { Component } from '@angular/core';

@Component({
	selector: 'app-maintenance',
	templateUrl: './maintenance.component.html'
})
export class MaintenanceComponent {
	reload() { window.location.reload(); }
}
